export default {
    createGroup: 'สร้างกลุ่ม',
    groupName: 'ชื่อกลุ่ม',
    checkInOption: 'ตัวเลือกการลงเวลา',
    checkInByLine: 'ลงเวลาผ่าน Line',
    checkInAnyWhere: 'ลงเวลาที่ไหนก็ได้',
    enterGroupName: 'ใส่ชื่อกลุ่ม',
    workday: 'เวลาทำงานประจำวัน',
    day: 'วัน',
    startTime: 'เวลาเริ่มงาน',
    breakHours: 'ช่วงพัก',
    endTime: 'เวลาเลิกงาน',
    status: 'สถานะ',
    active: 'เปิด',
    inactive: 'ปิด',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    msgCannotModify: 'ไม่สามารถเปลี่ยนเเปลงตารางของวันธรรมดาปัจจุบันได้',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    msgCreateSuccess: 'กลุ่มถูกสร้างแล้ว',
    msgUpdateSuccess: 'กลุ่มถูกอัปเดตแล้ว',
    msgError: 'เกิดข้อผิดพลาด',
    days: {
        monday: 'วันจันทร์',
        tuesday: 'วันอังคาร',
        wednesday: 'วันพุธ',
        thursday: 'วันพฤหัสบดี',
        friday: 'วันศุกร์',
        saturday: 'วันเสาร์',
        sunday: 'วันอาทิตย์'
    },
    // msgThanTimeStart: 'กรุณาเลือกช่วงเวลาเลิกงานหลังจากเวลา',
    checkInTime: 'เวลาเริ่มเช็คอิน',
    totalWorkHours: 'ชั่วโมงทำงาน',
    workingTimeEachDay: 'เวลาการทำงานในเเต่ละวันห้ามเกิน 24 ชม.',
    limitsWorkingHours: 'จำกัดชั่วโมงการทำงานห้ามเกิน 8 ชม. ต่อวัน เเละ 48 ชม. ต่อสัปดาห์',
    maximumLimitsOvertime: 'การทำงาน OT ห้ามเกิน 36 ชม. ต่อสัปดาห์',
    information: 'คำแนะนำ',
    checkInShouldAfterEndTime: 'เวลา check in ต้องตั้งหลังจากเวลา end time ของวันก่อนหน้า',
    incorrectWorkTimePeriod: 'ช่วงเวลาทำงานไม่ถูกต้อง',
    checkInTimeOverlapStartTime: 'เวลาเช็คอินคาบเกี่ยวกับเวลาเริ่มงาน',
    startTimeOverlapCheckInTime: 'เวลาเริ่มงานคาบเกี่ยวกับเวลาเช็คอิน',
    checkInTimeOverlapEndTime: 'เวลาเช็คอินคาบเกี่ยวกับกับเวลาเลิกงาน',
    endTimeOverlapCheckInTime: 'เวลาเลิกงานคาบเกี่ยวกับเวลาเช็คอิน',
    breakhoursIsRequired: 'breakhours is required',
    specialWorkdayOverlap: 'มีวันทำงานพิเศษทับซ้อนกับตารางเข้า - ออกงาน',
    otOverlap: 'มีการทำงานล่วงเวลาทับซ้อนกับตารางเข้า - ออกงาน',
    close: 'ปิด',
    error: 'พบข้อผิดพลาด'
}
